import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import apply_45fresh_45start_45global from "/app/middleware/apply-fresh-start.global.ts";
import auth_45global from "/app/middleware/auth.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  apply_45fresh_45start_45global,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}